export const getAllComps = (templateConfig) => {
  const {
    firstComponent,
    secondComponent,
    thirdComponent,
    fourthComponent,
    fifthComponent,
    sixthComponent
  } = templateConfig;

  return [firstComponent, secondComponent, thirdComponent, fourthComponent, fifthComponent, sixthComponent];
};
